<template>
  <div
    class="subpartContainer"
  >
    <QuestionnaireRadio
      content="Have you ever undergone a Radical Prostatectomy?<br>(Removal of Prostate Gland)"
      width="120px"
      mobileWidth="163px"
      :options="yesNoOptions"
      :value="this.hormoneZoomerQnr.basic_info.radical_prostatectomy"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('basic_info.radical_prostatectomy', $event)"
    />
  </div>
  <div
    class="subpartContainer"
  >
    <QuestionnaireRadio
      content="Have you had a bladder or prostate infection in the <br>last 12 months?"
      width="120px"
      mobileWidth="106px"
      :options="yesNoUnsureOptions"
      :value="this.hormoneZoomerQnr.basic_info.bladder_or_prostate_infection"
      :disabled="this.qnrIsCompleted"
      @onChange="
        handleValueChange('basic_info.bladder_or_prostate_infection', $event)
      "
    />
  </div>
  <div class="subTitleContainer">
    <div class="subTitle">Bone Health and Toxin Exposure</div>
  </div>
  <div
    class="subpartContainer"
  >
    <QuestionnaireRadio
      content="Have you ever had a bone density scan?"
      width="120px"
      mobileWidth="163px"
      :options="yesNoOptions"
      :disabled="this.qnrIsCompleted"
      :value="
        this.hormoneZoomerQnr.bone_health_and_toxic_exposure.bone_density_scan
      "
      @onChange="
        handleValueChange(
          'bone_health_and_toxic_exposure.bone_density_scan',
          $event
        )
      "
    />
  </div>
  <div
    class="expandedContainer"
    v-if="
      this.hormoneZoomerQnr.bone_health_and_toxic_exposure.bone_density_scan
    "
  >
    <QuestionnaireRadio
      content="If yes, what was the result?"
      width="165px"
      mobileWidth="151px"
      :options="boneDensityScanOptions"
      :disabled="this.qnrIsCompleted"
      :value="
        this.hormoneZoomerQnr.bone_health_and_toxic_exposure.bone_density_result
      "
      @onChange="
        handleValueChange(
          'bone_health_and_toxic_exposure.bone_density_result',
          $event
        )
      "
    />
  </div>
  <div
    class="subpartContainer"
  >
    <QuestionnaireRadio
      content="Have you experienced any fractures?"
      width="120px"
      mobileWidth="163px"
      :options="yesNoOptions"
      :disabled="this.qnrIsCompleted"
      :value="
        this.hormoneZoomerQnr.bone_health_and_toxic_exposure
          .experienced_fractures
      "
      @onChange="
        handleValueChange(
          'bone_health_and_toxic_exposure.experienced_fractures',
          $event
        )
      "
    />
  </div>
  <div
    class="subpartContainer"
  >
    <QuestionnaireRadio
      content="Have you ever been exposed to toxic substances?"
      width="120px"
      mobileWidth="106px"
      :options="yesNoUnsureOptions"
      :disabled="this.qnrIsCompleted"
      :value="
        this.hormoneZoomerQnr.bone_health_and_toxic_exposure
          .toxic_substance_exposure
      "
      @onChange="
        handleValueChange(
          'bone_health_and_toxic_exposure.toxic_substance_exposure',
          $event
        )
      "
    />
  </div>
  <div class="subTitleContainer">
    <div class="subTitle">Symptom Assessment</div>
    <div class="assessmentHint">
      Please rate the severity of the following symptoms on a scale of
      0-3:&nbsp; &nbsp;
      <b
        >0 = None&nbsp; &nbsp; 1 = Mild&nbsp; &nbsp; 2 = Moderate&nbsp; &nbsp; 3
        = Severe</b
      >
    </div>
  </div>
  <div
    class="subpartContainer"
  >
    <QuestionnaireRadio
      content="Fatigue / Low Energy"
      width="auto"
      mobileWidth="77.5px"
      :options="severityOptions"
      :value="this.hormoneZoomerQnr.symptom_assessment.fatigue"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('symptom_assessment.fatigue', $event)"
    />
  </div>
  <div
    class="subpartContainer"
  >
    <QuestionnaireRadio
      content="Decreased Sexual Desire (Libido)"
      width="auto"
      mobileWidth="77.5px"
      :options="severityOptions"
      :value="this.hormoneZoomerQnr.symptom_assessment.loss_of_libido"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('symptom_assessment.loss_of_libido', $event)"
    />
  </div>
  <div
    class="subpartContainer"
  >
    <QuestionnaireRadio
      content="Erectile Dysfunction"
      width="auto"
      mobileWidth="77.5px"
      :options="severityOptions"
      :value="this.hormoneZoomerQnr.symptom_assessment.erectile_dysfunction"
      :disabled="this.qnrIsCompleted"
      @onChange="
        handleValueChange('symptom_assessment.erectile_dysfunction', $event)
      "
    />
  </div>
  <div
    class="subpartContainer"
  >
    <QuestionnaireRadio
      content="Decreased Muscle Mass"
      width="auto"
      mobileWidth="77.5px"
      :options="severityOptions"
      :value="this.hormoneZoomerQnr.symptom_assessment.loss_of_muscle_mass"
      :disabled="this.qnrIsCompleted"
      @onChange="
        handleValueChange('symptom_assessment.loss_of_muscle_mass', $event)
      "
    />
  </div>
  <div
    class="subpartContainer"
  >
    <QuestionnaireRadio
      content="Increased Body Fat / Weight Gain"
      width="auto"
      mobileWidth="77.5px"
      :options="severityOptions"
      :value="this.hormoneZoomerQnr.symptom_assessment.increased_body_fat"
      :disabled="this.qnrIsCompleted"
      @onChange="
        handleValueChange('symptom_assessment.increased_body_fat', $event)
      "
    />
  </div>
  <div
    class="subpartContainer"
  >
    <QuestionnaireRadio
      content="Depression/anxiety"
      width="auto"
      mobileWidth="77.5px"
      :options="severityOptions"
      :value="this.hormoneZoomerQnr.symptom_assessment.depression_or_anxiety"
      :disabled="this.qnrIsCompleted"
      @onChange="
        handleValueChange('symptom_assessment.depression_or_anxiety', $event)
      "
    />
  </div>
  <div
    class="subpartContainer"
  >
    <QuestionnaireRadio
      content="Poor Concentration or Memory Problems"
      width="auto"
      mobileWidth="77.5px"
      :options="severityOptions"
      :value="this.hormoneZoomerQnr.symptom_assessment.difficulty_concentrating"
      :disabled="this.qnrIsCompleted"
      @onChange="
        handleValueChange('symptom_assessment.difficulty_concentrating', $event)
      "
    />
  </div>
  <div
    class="subpartContainer"
  >
    <QuestionnaireRadio
      content="Poor sleep"
      width="auto"
      mobileWidth="77.5px"
      :options="severityOptions"
      :value="this.hormoneZoomerQnr.symptom_assessment.poor_sleep"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('symptom_assessment.poor_sleep', $event)"
    />
  </div>
  <div
    class="subpartContainer"
  >
    <QuestionnaireRadio
      content="Reduced Physical Performance<br>(exercise capacity, strength)"
      width="auto"
      mobileWidth="77.5px"
      :options="severityOptions"
      :disabled="this.qnrIsCompleted"
      :value="
        this.hormoneZoomerQnr.symptom_assessment.reduced_physical_performance
      "
      @onChange="
        handleValueChange(
          'symptom_assessment.reduced_physical_performance',
          $event
        )
      "
    />
  </div>
  <div
    class="subpartContainer"
  >
    <QuestionnaireRadio
      content="Irritability or Mood Swings"
      width="auto"
      mobileWidth="77.5px"
      :options="severityOptions"
      :value="this.hormoneZoomerQnr.symptom_assessment.mood_swings"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('symptom_assessment.mood_swings', $event)"
    />
  </div>
  <div
    class="subpartContainer"
  >
    <QuestionnaireRadio
      content="Thinning or loss of hair"
      width="auto"
      mobileWidth="77.5px"
      :options="severityOptions"
      :value="this.hormoneZoomerQnr.symptom_assessment.loss_of_hair"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('symptom_assessment.loss_of_hair', $event)"
    />
  </div>
  <div class="subTitleContainer">
    <div class="subTitle">Medical History</div>
  </div>
  <div
    class="subpartContainer"
  >
    <QuestionnaireRadio
      content="Have you have a history of Hypogonadism<br>(low testosterone)? "
      width="120px"
      mobileWidth="106px"
      :options="yesNoUnsureOptions"
      :value="
        this.hormoneZoomerQnr.medical_history.personal_history.hypogonadism
      "
      :disabled="this.qnrIsCompleted"
      @onChange="
        handleValueChange(
          'medical_history.personal_history.hypogonadism',
          $event
        )
      "
    />
  </div>
  <div class="subpartContainer col-container">
    <QuestionnaireMultiChoice
      content="Do you have a history of:"
      width="auto"
      :options="maleDiseaseHistoryOptions"
      :value="this.comorbiditiesArray"
      :disabled="this.qnrIsCompleted"
      @onChange="handleComorbidityChange"
    />
  </div>
  <div
    class="expandedContainer"
    v-if="this.comorbiditiesArray.includes('other')"
  >
    <div class="title mb-[10px]">Please specify</div>
    <el-input
      v-model="
        this.hormoneZoomerQnr.medical_history.comorbidities.other_comorbidities
      "
      class="expandInputField"
      :disabled="this.qnrIsCompleted"
      :type="this.dynamic_input_type"
      @input="
        handleValueChange(
          'medical_history.comorbidities.other_comorbidities',
          $event
        )
      "
    />
  </div>
  <div class="subpartContainer col-container">
    <QuestionnaireMultiChoice
      content="Do you have a familial history of:"
      width="auto"
      :options="maleFamilyHistoryOptions"
      :value="this.familyHistoryArray"
      :disabled="this.qnrIsCompleted"
      @onChange="handleFamilyHistoryChange"
    />
  </div>
  <div
    class="expandedContainer"
    v-if="this.familyHistoryArray.includes('other')"
  >
    <div class="title mb-[10px]">Please specify</div>
    <el-input
      v-model="
        this.hormoneZoomerQnr.medical_history.family_history
          .other_family_conditions
      "
      class="expandInputField"
      :disabled="this.qnrIsCompleted"
      :type="this.dynamic_input_type"
      @input="
        handleValueChange('family_history.other_family_conditions', $event)
      "
    />
  </div>
  <div class="subTitleContainer">
    <div class="subTitle">Treatment Considerations</div>
  </div>
  <div
    class="subpartContainer flex flex-row justify-between items-center mb-[12px]"
  >
    <QuestionnaireRadio
      content="Do you have a hormone treatment preference?"
      width="132px"
      :options="HRTOptions"
      :value="
        this.hormoneZoomerQnr.treatment_considerations
          .hormone_treatment_preference
      "
      :disabled="this.qnrIsCompleted"
      @onChange="
        handleValueChange(
          'treatment_considerations.hormone_treatment_preference',
          $event
        )
      "
    />
  </div>
  <div
    class="subpartContainer"
  >
    <QuestionnaireRadio
      content="Do you have sensitive skin? (Affects certain forms of HRT)"
      width="132px"
      mobileWidth="163px"
      :options="yesNoOptions"
      :value="this.hormoneZoomerQnr.treatment_considerations.sensitive_skin"
      :disabled="this.qnrIsCompleted"
      @onChange="
        handleValueChange('treatment_considerations.sensitive_skin', $event)
      "
    />
  </div>
  <div
    class="subpartContainer"
  >
    <QuestionnaireRadio
      content="Are you currently undergoing HRT and/or taking any medications? "
      width="132px"
      mobileWidth="163px"
      :options="yesNoOptions"
      :value="
        this.hormoneZoomerQnr.treatment_considerations
          .undergoing_hormone_therapy
      "
      :disabled="this.qnrIsCompleted"
      @onChange="
        handleValueChange(
          'treatment_considerations.undergoing_hormone_therapy',
          $event
        )
      "
    />
  </div>
  <div
    class="expandedContainer"
    v-if="
      this.hormoneZoomerQnr.treatment_considerations.undergoing_hormone_therapy
    "
  >
    <div class="title mb-[10px]">Please specify</div>
    <el-input
      v-model="
        this.hormoneZoomerQnr.treatment_considerations.current_medications
      "
      class="expandInputField"
      :disabled="this.qnrIsCompleted"
      :type="this.dynamic_input_type"
      @input="
        handleValueChange(
          'treatment_considerations.current_medications',
          $event
        )
      "
    />
  </div>
</template>

<script>
import QuestionnaireRadio from "./QuestionnaireRadio.vue";
import QuestionnaireMultiChoice from "./QuestionnaireMultiChoice.vue";
import { useHormoneZoomerStore } from "@/stores/HormoneZoomerStore.ts";
import { mapState, mapActions } from "pinia";
import {
  reproductiveHealthStageOptions,
  yesNoOptions,
  severityOptions,
  yesNoUnsureOptions,
  HRTOptions,
  maleDiseaseHistoryOptions,
  maleFamilyHistoryOptions,
  boneDensityScanOptions,
} from "@/utils/questionnaireOptions";
import { useWindowSize } from "@vueuse/core";

export default {
  name: "MaleRelatedQuestions",
  components: {
    QuestionnaireRadio,
    QuestionnaireMultiChoice,
  },
  data() {
    return {
      gender: "",
      lastMenstrualPeriod: "",
      reproductiveHealthStageOptions,
      yesNoOptions,
      severityOptions,
      yesNoUnsureOptions,
      HRTOptions,
      maleDiseaseHistoryOptions,
      maleFamilyHistoryOptions,
      boneDensityScanOptions,
    };
  },
  setup() {
    const { width } = useWindowSize();
    return {
      width,
    };
  },
  watch: {
    boneDensityScan: {
      deep: true,
      handler: function (newValue) {
        if (!newValue) {
          this.setHormoneZoomerQnrSingleField(
            "bone_health_and_toxic_exposure.bone_density_result",
            null
          );
        }
      },
    },
    undergoingHormoneTherapy: {
      deep: true,
      handler: function (newValue) {
        if (!newValue) {
          this.setHormoneZoomerQnrSingleField(
            "treatment_considerations.current_medications",
            ""
          );
        }
      },
    },
  },
  computed: {
    ...mapState(()=>useHormoneZoomerStore(), [
      "hormoneZoomerQnr",
      "comorbiditiesArray",
      "familyHistoryArray",
      "qnrIsCompleted",
    ]),
    dynamic_input_type() {
      return this.width <= 808 ? "textarea" : "text";
    },
    boneDensityScan() {
      return this.hormoneZoomerQnr.bone_health_and_toxic_exposure
        .bone_density_scan;
    },
    undergoingHormoneTherapy() {
      return this.hormoneZoomerQnr.treatment_considerations
        .undergoing_hormone_therapy;
    },
  },
  methods: {
    ...mapActions(()=>useHormoneZoomerStore(), [
      "getZoomerQnrData",
      "submitHormoneZoomerQnr",
      "setHormoneZoomerQnrSingleField",
      "setComorbiditiesArray",
      "setFamilyHistoryArray",
      "convertHormoneZoomerQnrArrayToObject",
    ]),
    handleValueChange(key, value) {
      this.setHormoneZoomerQnrSingleField(key, value);
    },
    handleComorbidityChange(value) {
      this.setComorbiditiesArray(value);
      this.convertHormoneZoomerQnrArrayToObject("comorbidities", value);
    },
    handleFamilyHistoryChange(value) {
      this.setFamilyHistoryArray(value);
      this.convertHormoneZoomerQnrArrayToObject("family_history", value);
    },
  },
};
</script>

<style scoped>
.subpartContainer {
  width: 100%;
  padding: 0px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.col-container {
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 20px;
}

.inputField {
  height: 42px;
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0.4px;
  color: #000000;
  border-radius: 4px;
}

.inputTextarea {
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0.4px;
  color: #000000;
}

:deep(.el-input__inner) {
  color: #000000;
}

:deep(.el-textarea__inner) {
  caret-color: #000 !important;
  color: #000000;
  white-space: normal;
  resize: none;
  height: 126px;
  box-shadow: none;
  border: 1px solid #bcccdc;
}

:deep(.el-input__wrapper) {
  box-shadow: none;
  border: 1px solid #bcccdc;
  padding-left: 21px;
}

.subTitleContainer {
  padding: 12px 24px;
  border-radius: 4px;
  background-color: #faece6;
  margin-top: 36px;
  margin-bottom: 24px;
}

.subTitle {
  color: #0e4672;
  font-family: Roboto;
  font-weight: 500;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0.17px;
}

.assessmentHint {
  font-family: Roboto;
  font-size: 14px;
  margin-top: 8px;
}

.assessmentHint b {
  padding-left: 15px;
  font-weight: 700;
  font-style: italic;
}

.expandedContainer {
  padding: 12px 24px;
  border-radius: 4px;
  background-color: #f3f6f8;
  margin: 12px 16px;
}

:deep(.el-input.is-disabled .el-input__wrapper) {
  background-color: #f2f2f2;
}

:deep(.el-input.is-disabled .el-input__inner) {
  -webkit-text-fill-color: #1C1C1C;
}

:deep(.el-textarea.is-disabled .el-textarea__inner) {
  background-color: #f2f2f2;
  -webkit-text-fill-color: #1c1c1c;
}

@media only screen and (max-width: 808px) {
  .subpartContainer {
    width: 100%;
    padding: 0px 8px;
    margin-bottom: 12px;
    flex-direction: column;
    align-items: flex-start;
  }

  .inputField {
    width: 334px;
    height: 42px;
    font-size: 12px;
    line-height: 14px;
    letter-spacing: 0.4px;
  }

  .subpartContainer .title {
    font-size: 14px;
  }

  .subTitleContainer {
    padding: 12px 16px;
    margin-top: 24px;
    margin-bottom: 12px;
  }

  .subTitle {
    font-size: 14px;
    line-height: 16px;
  }

  .expandedContainer {
    padding: 12px 16px;
    margin: 12px 8px;
    font-size: 12px;
  }

  .assessmentHint {
    font-size: 12px;
    line-height: 14px;
  }

  .assessmentHint b {
    display: block;
  }

  :deep(.el-textarea__inner) {
    font-size: 12px;
    line-height: 16px;
  }

  .expandInputField{
    height: 100px;
    font-size: 14px;
    font-weight: 400;
    line-height: 19px;
    letter-spacing: 0.4px;
    color: #000000;
    border-radius: 4px;
    width: 310px;
  }

  .expandedContainer :deep(.el-textarea__inner) {
    height: 100px;
  }
}
</style>
